import {useEffect, useState} from 'react'
import { getLogSAPTypes } from 'src/api/modules/getdatalist'

/**
 * Hook yang digunakan untuk mendapatkan data regions
 */
export const useLogSAPTypes = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [options, setOptions] = useState<{label: string; value: string}[]>([])

  const fetchData = async () => {
    setIsLoading(true)
    const res = await getLogSAPTypes()
    setOptions(
      res.data.data.map((item: {value: number; label: string}) => ({
        label: item.label,
        value: item.value,
      }))
    )
    setIsLoading(false)
  }
  useEffect(() => {
    fetchData()
  }, [])

  return {options, isLoading}
}
